<template>
  <div class="app-toast-host" aria-live="polite">
    <div
      v-for="item in items"
      :key="item.id"
      class="app-toast"
      :class="[
        `is-${item.type}`,
        item.leaving ? 'is-leave' : 'is-enter',
      ]"
    >
      <div v-if="item.type !== 'info'" class="app-toast-icon" :class="`is-${item.type}`">
        <decision-icon
          v-if="item.type === 'error'"
          type="no"
          color="#ffffff"
          size="12px"
        />
        <decision-icon
          v-else
          type="yes"
          color="#ffffff"
          size="12px"
        />
      </div>
      <span class="app-toast-text">{{ item.title }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useToastStore } from '@/store/toast';
import DecisionIcon from '@/components/decision-icon/index.vue';

const store = useToastStore();
const items = computed(() => store.items);
</script>

<style lang="scss" scoped>
#app-toast-root {
  position: fixed;
  inset: 0;
  z-index: 2147483000;
  pointer-events: none;
}

/* 顶部下拉：按内容撑开，不占满屏宽 */
.app-toast-host {
  position: fixed;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  z-index: 2147483000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: min(420px, calc(100vw - 32px));
  max-width: calc(100vw - 32px);
  padding-top: calc(12px + env(safe-area-inset-top, 0px));
  pointer-events: none;
  box-sizing: border-box;
}

.app-toast {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: max-content;
  max-width: 100%;
  min-height: 48px;
  padding: 12px 16px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 8px 28px rgba(17, 24, 39, 0.16);
  box-sizing: border-box;
  will-change: transform, opacity;
}

.app-toast-icon {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-toast-icon.is-success,
.app-toast-icon.is-info {
  background: #22c55e;
}

.app-toast-icon.is-error {
  background: #ef4444;
}

.app-toast-text {
  flex: 1 1 auto;
  min-width: 0;
  color: #1f2937;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.35;
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
}

.app-toast.is-enter {
  animation: appToastIn 0.38s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.app-toast.is-leave {
  animation: appToastOut 0.28s ease-in both;
}

@keyframes appToastIn {
  from {
    opacity: 0;
    transform: translateY(-120%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes appToastOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-120%);
  }
}
</style>
